<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">

          <div class="card-header pb-0">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h6 class="mb-0">Tallas disponibles</h6>
              <div class="d-flex gap-2">
                <button
                  v-if="shopifyActive"
                  type="button"
                  class="btn btn-outline-success btn-sm"
                  @click="syncShopify"
                  :disabled="isSyncing"
                >
                  <i class="fa fa-sync me-1" :class="{ 'fa-spin': isSyncing }"></i>
                  {{ isSyncing ? 'Sincronizando...' : 'Sincronizar Shopify' }}
                </button>
                <button
                  v-if="kubappActive"
                  type="button"
                  class="btn btn-outline-primary btn-sm"
                  @click="syncKubapp"
                  :disabled="isSyncingKubapp"
                >
                  <i class="fa fa-sync me-1" :class="{ 'fa-spin': isSyncingKubapp }"></i>
                  {{ isSyncingKubapp ? 'Sincronizando...' : 'Sincronizar Kubapp' }}
                </button>
                <router-link
                  :to="{ name: 'Inventory Create', query: suppliesListQuery }"
                  class="btn btn-primary btn-sm"
                  data-toggle="tooltip"
                  data-original-title="Agregar insumo"
                >
                  Agregar <i class="fa fa-plus ms-1"></i>
                </router-link>
              </div>
            </div>
            <div class="row align-items-end">
              <!-- Columna de búsqueda -->
              <div class="col-md-4 mb-3">
                <label for="searchQuery" class="mb-1">Buscar</label>
                <input
                  type="text"
                  v-model="searchQuery"
                  id="searchQuery"
                  class="form-control"
                  placeholder="Buscar producto..."
                  @input="onSearchInput"
                />
              </div>
              <div class="col-md-2 mb-3">
                <div class="form-check form-switch mt-4">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="hideZeroStock"
                    v-model="hideZeroStock"
                    @change="onToggleZeroStock"
                  />
                  <label class="form-check-label" for="hideZeroStock">Ocultar sin stock</label>
                </div>
              </div>
              <div class="col-md-6 mb-3 text-end">
                <button
                  type="button"
                  class="btn btn-sm btn-outline-danger me-2"
                  @click="exportPdf"
                  :disabled="isExportingPdf"
                >
                  <i class="fa fa-file-pdf me-1"></i> Generar PDF
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  @click="exportCsv"
                  :disabled="isExporting"
                >
                  <i class="fa fa-download me-1"></i> Exportar Excel
                </button>
              </div>
            </div>
          </div>

          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">

              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th style="width:60px"></th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Producto</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Ref</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Stock
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      P. Compra
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      P. Venta
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      P. Venta 2
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" title="Mostrar este producto en el catálogo público">
                      Catálogo
                    </th>
                    <th v-if="shopifyActive" class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" title="Enviar este producto a Shopify al sincronizar">
                      Shopify
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Semáforo
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Estado
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Última modificación
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Opciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="value in data" :key="value.id">
                    <td class="align-middle text-center" style="width:60px">
                      <div
                        class="inventory-img-wrapper"
                        @click="triggerImageUpload(value)"
                        :title="value.image_url ? 'Cambiar imagen' : 'Subir imagen'"
                      >
                        <img
                          v-if="value.image_url"
                          :src="value.image_url"
                          class="inventory-thumb"
                          alt="imagen"
                        />
                        <div v-else class="inventory-thumb-placeholder">
                          <i class="fa fa-image text-secondary"></i>
                        </div>
                        <div class="inventory-img-overlay">
                          <i class="fa fa-camera"></i>
                        </div>
                      </div>
                      <input
                        type="file"
                        accept="image/jpg,image/jpeg,image/png,image/webp"
                        class="d-none"
                        :ref="'imgInput_' + value.id"
                        @change="onImageSelected($event, value)"
                      />
                    </td>
                    <td>
                      <div class="d-flex align-items-center px-2 py-1">
                        <i
                          v-if="value.has_pending_purchase"
                          class="fa fa-clock text-warning me-2"
                          title="Compra pendiente"
                          aria-hidden="true"
                        />
                        <div class="d-flex flex-column justify-content-center">
                          <router-link
                            :to="{ name: 'Inventory Edit', params: { id: value.id }, query: suppliesListQuery }"
                            class="text-decoration-none"
                          >
                            <h6 class="mb-0 text-sm text-secondary">{{ value.name }}</h6>
                          </router-link>
                        </div>
                      </div>
                    </td>
                    <td style="max-width:150px">
                      <div class="px-2 py-1" style="max-width:150px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap" :title="value.ref">
                        <h6 class="mb-0 text-sm" style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap">{{ value.ref }}</h6>
                        <span class="badge badge-sm mt-1" :class="value.shopify_id ? 'bg-gradient-success' : 'bg-gradient-secondary'">
                          {{ value.shopify_id ? 'Shopify' : 'Local' }}
                        </span>
                      </div>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <a
                        class="stock-link cursor-pointer"
                        title="Ver variaciones"
                        @click="openVariantsModal(value)"
                      >
                        {{ value.quantity }}
                      </a>
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ formatPrice(value.price) }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ formatPrice(value.sale_price) }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ formatPrice(value.sale_price_2) }}
                    </td>
                    <td class="align-middle text-center">
                      <input
                        type="checkbox"
                        :checked="value.show_in_catalog"
                        :disabled="savingCatalogId === value.id"
                        title="Mostrar este producto en el catálogo público"
                        @change="onCatalogCheck(value, $event)"
                      />
                    </td>
                    <td v-if="shopifyActive" class="align-middle text-center">
                      <input
                        type="checkbox"
                        :checked="value.sync_shopify"
                        :disabled="savingShopifyId === value.id"
                        title="Enviar este producto a Shopify al sincronizar"
                        @change="onShopifyCheck(value, $event)"
                      />
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="badge badge-sm" :class="{
                        'bg-gradient-danger': value.quantity <= value.low,
                        'bg-gradient-warning': value.quantity <= value.medium,
                        'bg-gradient-success': value.quantity >= value.medium,
                      }">
                        {{
                          value.quantity >= value.high
                            ? 'Alto'
                            : value.quantity > value.low
                              ? 'Medio'
                              : 'Bajo'
                        }}
                      </span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="badge badge-sm"
                        :class="value.status == 1 ? 'bg-gradient-success' : 'bg-gradient-warning'">
                        {{ value.status == 1 ? 'Activo' : 'Inactivo' }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ new Date(value.updated_at).toLocaleDateString('es-ES') }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <router-link
                        :to="{ name: 'Inventory Edit', params: { id: value.id }, query: suppliesListQuery }"
                        class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                        data-original-title="Editar Registro">
                        <i class="fa fa-pencil-alt"></i>
                      </router-link>

                      <a v-if="shopifyActive && value.sync_shopify" @click="syncProductToShopify(value)" class="text-success font-weight-bold text-xs cursor-pointer"
                        style="margin-left: 12px;" data-toggle="tooltip" data-original-title="Sincronizar con Shopify">
                        <i class="fab fa-shopify" style="font-size: 14px;"></i>
                      </a>

                      <a @click="deleteUser(value.id)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                        style="margin-left: 15px;" data-toggle="tooltip" data-original-title="Eliminar registro">
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>
                  </tr>

                  <tr v-if="data.length === 0">
                    <td :colspan="shopifyActive ? 13 : 12" class="text-center text-xxs">No hay registros disponibles</td>
                  </tr>
                </tbody>
              </table>

              <!-- Paginación -->
              <div class="pagination p-3">
                <a v-for="link in links" :key="link.label" class="page-item cursor-pointer" @click="fetchData(link.url)"
                  :disabled="!link.url || link.active" :class="{ 'active': link.label === currentPage.toString() }">
                  {{ link.label }}
                </a>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- Modal de variaciones del producto -->
    <div v-if="variantsModalProduct" class="variants-modal-overlay" @click.self="closeVariantsModal">
      <div class="variants-modal card shadow">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <h6 class="mb-0">
              <i class="fas fa-layer-group me-1"></i>
              Variaciones · {{ variantsModalProduct.name }}
            </h6>
            <button type="button" class="btn-close" @click="closeVariantsModal"></button>
          </div>

          <div v-if="loadingVariants" class="text-center text-secondary text-sm py-4">
            <i class="fa fa-spinner fa-spin me-1"></i> Cargando variaciones...
          </div>
          <div v-else-if="modalVariants.length === 0" class="text-center text-secondary text-sm py-4">
            Este producto no tiene variaciones.
          </div>
          <div v-else class="table-responsive variants-modal-body">
            <table class="table align-items-center mb-0">
              <thead>
                <tr>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Color</th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Talla</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Código</th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Stock</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="variant in modalVariants" :key="variant.id">
                  <td class="text-sm">
                    <span
                      v-if="variant.color_hex"
                      class="color-dot me-1"
                      :style="{ background: variant.color_hex }"
                    ></span>
                    {{ variant.color_name || '—' }}
                  </td>
                  <td class="text-center text-sm">{{ variant.size_name || '—' }}</td>
                  <td class="text-sm text-secondary">{{ variant.barcode || '—' }}</td>
                  <td class="text-center text-sm font-weight-bold">{{ variant.quantity }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="3" class="text-end text-sm text-secondary">Total</td>
                  <td class="text-center text-sm font-weight-bold">{{ modalVariantsTotal }}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
import inventoryService from '../../../services/inventory.service';
import shopifyService from '../../../services/shopify.service';

export default {
  name: 'ProjectsList',
  data() {
    return {
      searchQuery: '',
      hideZeroStock: true,
      isExporting: false,
      isExportingPdf: false,
      isImporting: false,
      isSyncing: false,
      cancelShopifySync: false,
      isSyncingKubapp: false,
      syncingProductId: null,
      uploadingImageId: null,
      savingCatalogId: null,
      savingShopifyId: null,
      shopifyActive: false,
      kubappActive: false,
      variantsModalProduct: null,
      modalVariants: [],
      loadingVariants: false,
    };
  },
  computed: {
    ...mapGetters('inventory', ['allData', 'currentPage', 'lastPage', 'pagination', 'links']),
    currentPage() {
      return this.$store.state.inventory.currentPage;
    },
    lastPage() {
      return this.$store.state.inventory.lastPage;
    },
    data() {
      return this.allData;
    },
    links() {
      return this.$store.getters['inventory/links'];
    },
    suppliesListQuery() {
      const s = (this.searchQuery || '').trim();
      const q = s ? { search: s } : {};
      if (!this.hideZeroStock) q.zero = '1';
      return q;
    },
    modalVariantsTotal() {
      return this.modalVariants.reduce((sum, v) => sum + Number(v.quantity || 0), 0);
    },
  },
  created() {
    const raw = this.$route.query.search;
    if (raw !== undefined && raw !== null && raw !== '') {
      this.searchQuery = Array.isArray(raw) ? String(raw[0]) : String(raw);
    }
    this.hideZeroStock = this.$route.query.zero !== '1';
  },
  methods: {
    formatPrice(value) {
      const numericValue = Number(value ?? 0);
      if (!Number.isFinite(numericValue)) return '0';
      return Math.floor(numericValue).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    async openVariantsModal(item) {
      this.variantsModalProduct = item;
      this.modalVariants = [];
      this.loadingVariants = true;
      try {
        const res = await inventoryService.getVariants(item.id);
        // Evita pintar la respuesta de un producto anterior si el modal ya cambió
        if (this.variantsModalProduct?.id === item.id) {
          this.modalVariants = res.data || [];
        }
      } catch (error) {
        console.error('Error al cargar variaciones:', error);
        this.closeVariantsModal();
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.response?.data?.message || 'No se pudieron cargar las variaciones',
        });
      } finally {
        this.loadingVariants = false;
      }
    },
    closeVariantsModal() {
      this.variantsModalProduct = null;
      this.modalVariants = [];
    },
    syncSearchQueryToUrl() {
      const next = { ...this.$route.query };
      const trimmed = (this.searchQuery || '').trim();
      if (trimmed) {
        next.search = trimmed;
      } else {
        delete next.search;
      }
      if (this.hideZeroStock) {
        delete next.zero;
      } else {
        next.zero = '1';
      }
      if (JSON.stringify(next) === JSON.stringify(this.$route.query)) {
        return;
      }
      this.$router.replace({ query: next }).catch(() => {});
    },
    onSearchInput() {
      this.syncSearchQueryToUrl();
      this.fetchData(null);
    },
    onToggleZeroStock() {
      this.syncSearchQueryToUrl();
      this.fetchData(null);
    },
    async onCatalogCheck(item, event) {
      const checked = event.target.checked;
      const original = !!item.show_in_catalog;
      // Reflejar el cambio de inmediato; se revierte si falla el guardado
      item.show_in_catalog = checked;
      if (this.savingCatalogId === item.id) return;
      this.savingCatalogId = item.id;
      try {
        await inventoryService.setCatalogFlag(item.id, checked);
      } catch (error) {
        this.revertCatalogCheck(item, event, original);
        console.error('Error al actualizar catálogo:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.response?.data?.message || 'No se pudo actualizar la visibilidad en el catálogo',
        });
      } finally {
        this.savingCatalogId = null;
      }
    },
    revertCatalogCheck(item, event, original) {
      item.show_in_catalog = original;
      if (event?.target) event.target.checked = original;
    },
    async onShopifyCheck(item, event) {
      const checked = event.target.checked;
      const original = !!item.sync_shopify;
      // Reflejar el cambio de inmediato; se revierte si falla el guardado
      item.sync_shopify = checked;
      if (this.savingShopifyId === item.id) return;
      this.savingShopifyId = item.id;
      try {
        await inventoryService.setShopifyFlag(item.id, checked);
      } catch (error) {
        this.revertShopifyCheck(item, event, original);
        console.error('Error al actualizar marca de Shopify:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.response?.data?.message || 'No se pudo actualizar la sincronización con Shopify',
        });
      } finally {
        this.savingShopifyId = null;
      }
    },
    revertShopifyCheck(item, event, original) {
      item.sync_shopify = original;
      if (event?.target) event.target.checked = original;
    },
    async fetchData(pageUrl = null) {
      const params = {
        search: this.searchQuery,
        hide_zero_stock: this.hideZeroStock ? 1 : 0,
        page: pageUrl ? new window.URL(pageUrl).searchParams.get("page") || 1 : 1
      };
      await this.$store.dispatch('inventory/fetchData', params);
    },
    async exportCsv() {
      if (this.isExporting) return;
      this.isExporting = true;
      try {
        const response = await this.$store.dispatch('inventory/exportCsv', this.searchQuery || null);
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', 'insumos.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
        await Swal.fire('Listo', 'Archivo Excel descargado correctamente.', 'success');
      } catch (error) {
        console.error('Error al exportar:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.data?.message || 'Error al exportar el Excel',
        });
      } finally {
        this.isExporting = false;
      }
    },
    async exportPdf() {
      if (this.isExportingPdf) return;
      this.isExportingPdf = true;
      try {
        const response = await inventoryService.exportPdf(this.searchQuery || null);
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
      } catch (error) {
        console.error('Error al generar PDF:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.data?.message || 'Error al generar el PDF',
        });
      } finally {
        this.isExportingPdf = false;
      }
    },
    async handleFileImport(event) {
      const file = event.target.files?.[0];
      const fileInput = event.target;
      if (!file) return;
      if (this.isImporting) return;
      this.isImporting = true;
      try {
        await this.$store.dispatch('inventory/importCsv', file);
        await Swal.fire('Listo', 'Insumos importados correctamente.', 'success');
        this.fetchData();
      } catch (error) {
        const msg = error?.data?.message || 'Error al importar el CSV';
        const errors = error?.data?.errors;
        const detail = errors?.length
          ? `Errores en filas: ${errors.map((e) => e.fila).join(', ')}`
          : '';
        await Swal.fire({
          icon: 'error',
          title: 'Error al importar',
          text: detail ? `${msg} ${detail}` : msg,
        });
      } finally {
        this.isImporting = false;
        if (fileInput) fileInput.value = '';
      }
    },
    triggerImageUpload(item) {
      const input = this.$refs['imgInput_' + item.id];
      if (input) {
        if (Array.isArray(input)) input[0].click();
        else input.click();
      }
    },
    async onImageSelected(event, item) {
      const file = event.target.files?.[0];
      const inputEl = event.target;
      const itemId = item.id;
      if (!file) return;
      if (this.uploadingImageId === itemId) return;
      this.uploadingImageId = itemId;
      try {
        const response = await this.$store.dispatch('inventory/uploadImage', { id: itemId, file });
        const newUrl = response?.data?.image_url;
        if (newUrl) {
          const storeItem = this.data.find((i) => i.id === itemId);
          if (storeItem) storeItem.image_url = newUrl;
        }
      } catch (error) {
        console.error('Error subiendo imagen:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.data?.message || 'No se pudo subir la imagen',
        });
      } finally {
        this.uploadingImageId = null;
        inputEl.value = '';
      }
    },
    async syncShopify() {
      if (this.isSyncing) return;
      this.isSyncing = true;
      try {
        const { data: products } = await shopifyService.getMarkedProducts();
        if (!products?.length) {
          await Swal.fire('Sin productos', 'No hay productos marcados para sincronizar con Shopify.', 'info');
          return;
        }

        // Un producto por petición: cada request es corta y no la corta el servidor (503/timeout)
        this.cancelShopifySync = false;
        Swal.fire({
          title: 'Sincronizando con Shopify',
          html: '',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          showCancelButton: true,
          cancelButtonText: 'Detener',
        }).then(result => {
          if (result.isDismissed) this.cancelShopifySync = true;
        });

        let created = 0;
        let updated = 0;
        const errors = [];
        let processed = 0;
        for (const product of products) {
          if (this.cancelShopifySync) break;
          const label = [product.ref, product.name].filter(Boolean).join(' - ');
          const container = Swal.getHtmlContainer();
          if (container) {
            container.innerHTML = `<i class="fa fa-spinner fa-spin me-1"></i> ${processed + 1} de ${products.length}`
              + `<br><span class="text-sm text-secondary">${this.escapeHtml(label)}</span>`;
          }
          try {
            const res = await shopifyService.syncProduct(product.id);
            res.data?.action === 'created' ? created++ : updated++;
          } catch (error) {
            const status = error?.response?.status;
            const message = error?.response?.data?.message
              || (status ? `Error HTTP ${status}` : 'Sin respuesta del servidor');
            errors.push({ inventory_id: product.id, ref: product.ref, name: product.name, errors: [message] });
            // Shopify deshabilitado o sin permisos: los demás también fallarían
            if (status === 401 || status === 403) break;
          }
          processed++;
        }
        const stopped = processed < products.length;
        Swal.close();

        const summary = `${created} creados, ${updated} actualizados en Shopify`
          + (errors.length ? `, ${errors.length} con error` : '')
          + (stopped ? `. Se detuvo en ${processed} de ${products.length}.` : '.');
        await Swal.fire({
          icon: errors.length || stopped ? 'warning' : 'success',
          title: stopped ? 'Sincronización detenida' : 'Sincronización completada',
          width: errors.length ? 720 : undefined,
          html: this.escapeHtml(summary) + (errors.length ? this.shopifyIssuesHtml(errors) : ''),
        });
        this.fetchData();
      } catch (error) {
        console.error('Error al sincronizar con Shopify:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.response?.data?.message || 'Error al sincronizar con Shopify',
        });
      } finally {
        this.isSyncing = false;
      }
    },
    // Lista de productos con sus errores (rojo) y advertencias (amarillo) para mostrar en Swal
    shopifyIssuesHtml(items) {
      const rows = items.map(i => {
        const title = [i.ref, i.name].filter(Boolean).join(' - ') || `Producto #${i.inventory_id}`;
        const lines = [
          ...(i.errors || []).map(m => `<li class="text-danger">${this.escapeHtml(m)}</li>`),
          ...(i.warnings || []).map(m => `<li class="text-warning">${this.escapeHtml(m)}</li>`),
        ].join('');
        return `<div class="mb-2"><b>${this.escapeHtml(title)}</b><ul class="mb-0 ps-3">${lines}</ul></div>`;
      }).join('');
      return `<div class="text-start text-xs mt-3 border-top pt-2" style="max-height: 50vh; overflow-y: auto;">${rows}</div>`;
    },
    escapeHtml(text) {
      return String(text ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    },
    async syncKubapp() {
      if (this.isSyncingKubapp) return;
      this.isSyncingKubapp = true;
      try {
        const response = await inventoryService.syncKubapp();
        const data = response?.data;
        await Swal.fire(
          'Sincronización completada',
          data?.message || `${data?.created ?? 0} creados, ${data?.updated ?? 0} actualizados.`,
          'success'
        );
        this.fetchData();
      } catch (error) {
        console.error('Error al sincronizar con kubApp:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.response?.data?.message || 'Error al sincronizar con kubApp',
        });
      } finally {
        this.isSyncingKubapp = false;
      }
    },
    async syncProductToShopify(product) {
      if (this.syncingProductId === product.id) return;
      this.syncingProductId = product.id;
      try {
        Swal.fire({
          title: 'Sincronizando con Shopify...',
          text: `Producto: ${product.name}`,
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => Swal.showLoading(),
        });
        const res = await shopifyService.syncProduct(product.id);
        const data = res.data;
        Swal.close();
        await Swal.fire({
          icon: 'success',
          title: data.action === 'created' ? 'Producto creado' : 'Producto actualizado',
          text: data.message,
          confirmButtonText: 'Aceptar',
        });
        this.fetchData();
      } catch (error) {
        Swal.close();
        console.error('Error al sincronizar producto con Shopify:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.response?.data?.message || 'Error al sincronizar el producto con Shopify',
        });
      } finally {
        this.syncingProductId = null;
      }
    },
    async deleteUser(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar',
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch('inventory/delete', userId);
          if (response && response.status >= 200 && response.status < 300) {
            this.fetchData();
            await Swal.fire(
              'Eliminado!',
              'El registro se ha eliminado correctamente.',
              'success'
            );
          } else {
            throw new Error(response.data.message || 'Error al eliminar el usuario');
          }
        }
      } catch (error) {
        console.error('Error al eliminar el registro:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
  },
  async mounted() {
    this.fetchData();
    try {
      const res = await this.$store.dispatch('settings/get');
      this.shopifyActive = !!res.data.shopify_active;
      this.kubappActive = !!res.data.kubapp_active;
    } catch (e) {
      console.error('Error loading settings:', e);
    }
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.page-item {
  margin: 0 5px;
}

.active {
  font-weight: bold;
}

.inventory-img-wrapper {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 44px;
  cursor: pointer;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #e0e0e0;
}

.inventory-thumb {
  width: 44px;
  height: 44px;
  object-fit: cover;
  display: block;
}

.inventory-thumb-placeholder {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  font-size: 18px;
}

.inventory-img-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 16px;
  opacity: 0;
  transition: opacity 0.18s;
}

.inventory-img-wrapper:hover .inventory-img-overlay {
  opacity: 1;
}

.stock-link {
  color: #5e72e4;
  font-weight: 600;
  text-decoration: underline dotted;
}

.variants-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1080;
}

.variants-modal {
  width: 100%;
  max-width: 640px;
  margin: 1rem;
}

.variants-modal-body {
  max-height: 60vh;
  overflow-y: auto;
}

.color-dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 1px solid #ddd;
  vertical-align: middle;
}
</style>
